import React, {useEffect} from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Divider from "@mui/material/Divider";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import styles from "./SideBarStepper.module.css";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import { translate } from "../../../utils/utils";
import { useTranslation } from "react-i18next";
import useOnClickOutside from "../../../hooks/useOnClickOutside";
import Chip from "@mui/material/Chip";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import moment from "moment";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useSelector } from "react-redux";

export default function SideBarStepper({
  goToDashbord,
  quizDecription,
  quizTitle,
  questionNumbers,
  activeStep,
  steps,
  changeStep,
  handleClickQuestion,
  currentQuestion,
  payload,
  isMobile,
  isOpen,
  toggleAside,
  version,
  difficultyLevel,
  forwarded,
  totalUseCases,
  answredUseCases,
  isForwardedQuiz,
  thresholdsPayload,
  submissionDate,
  is_completed,
  duration,
  
}) {



  const CustomStepIcon = (props, step) => {
    const started = step.questions.map((el) => el.id).some((e) => !!payload[e]);
    const completed =
      step.questions.map((el) => el.id).every((e) => !!payload[e]) ||
      thresholdsPayload[step.id] >= step.threshold;
    const forwrdedUseCase =
      
        forwarded?.some((item) => item?.usecase_id === step.id)
      ;
    const questionAnswred = step.questions
      .filter((el) =>
        forwarded?.map((question) => question.question_id).includes(el.id)
      )
      .map((el) => el.id)
      .every((e) => payload[e] !== 0);


    return (
      <div
        style={{
          textAlign: "center",
          backgroundColor: completed &&!forwrdedUseCase? "#0FB694" : "#eaeaf0",
          width: "25px",
          height: "25px",
          borderRadius: "50%",
          padding: "2px",
          color: completed&&!forwrdedUseCase ? "#FFFFFF" : "#000000",
        }}
      >

        { completed &&!forwrdedUseCase ? (
          <CheckIcon />
        ) : started || forwrdedUseCase ? (
          <PriorityHighIcon />
        ) : (
          <span>{props.icon}</span>
        )}
      </div>
    );
  };

  const reportId = useSelector((state) => state.quizzes.reportId);


  const questionAnswred = () => {
    const length = Object.values(
      Object.fromEntries(
        Object.entries(payload).filter(([key]) =>
          forwarded
            .map((question) => question.question_id)
            .includes(Number(key))
        )
      )
    ).filter((el) => el !== 0).length;

    return `${t("total_question_answred")}: ${length} / ${questionNumbers}`;
  };

  const getColor = (level) => {
    if (level === "Easy") {
      return "acceptable";
    } else if (level === "Medium") {
      return "moderate";
    } else if (level === "Hard") {
      return "critical";
    } else {
      return "disabled";
    }
  };

  const handleStep = (index, step) => () => {
    changeStep(index);
    toggleAside();
  };

  const asideRef = React.useRef();
  useOnClickOutside(asideRef, isMobile && isOpen ? toggleAside : () => null);

  const { t } = useTranslation();
  const orgaId = localStorage.getItem("orgaId");

  return (
    <Box
      ref={asideRef}
      className={`aside ${isMobile ? "mobile" : ""} ${isOpen ? "open" : ""}`}
      sx={{
        height: "100vh",
        overflow: "auto",
        width: isMobile ? 355 : 400,
        padding: "40px 20px 10px 30px",
        borderRight: "1px solid rgba(0, 0, 0, 0.2)",
        boxSizing: "border-box",
      }}
    >
      {isMobile && (
        <CloseIcon
          onClick={toggleAside}
          style={{ position: "absolute", top: 15, right: 15 }}
        />
      )}
      <div style={{ display: "flex", alignItems: "center" }}>
        <IconButton onClick={goToDashbord}>
          <KeyboardBackspaceIcon />
        </IconButton>
        <span className={styles.button_title}>{t("back_to_dashboard")}</span>
      </div>
      <p className={styles.quiz_title}>{quizTitle}</p>
      {is_completed && (
        <div
          style={{
            marginBottom: "10px",
            marginTop: "-20px",
            display: "flex",
            gap: 10,
            justifyContent: "start",
          }}
        >
          {/* <Chip
            sx={{ height: "25px" }}
            label={
              <span style={{ fontSize: "14px", color: "#797979" }}>
                {moment(submissionDate).format("DD-MM-YYYY")}
              </span>
            }
            variant="outlined"
          /> */}

          <Chip
            sx={{ height: "25px" }}
            color="button"
            label={
              <a
                id="link"
                href={`${process.env.REACT_APP_ORIGIN_URL}/reports/${reportId}?orga_id=${orgaId}&download=False`}
                target="_blank"
                style={{ fontSize: "13px" }}
              >
                <OpenInNewIcon sx={{ fontSize: "14px" }} />{" "}
                {t("consult_report")}
              </a>
            }
            variant="outlined"
          />
        </div>
      )}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Chip
          label={t(difficultyLevel) || t("Unknow")}
          variant="outlined"
          color={getColor(difficultyLevel)}
          icon={<FiberManualRecordIcon />}
          sx={{ width: "40%" }}
        />
        <Chip label={`Version ${version || 0}`} variant="outlined" />
        <Chip
          label={`${duration} min`}
          variant="outlined"
          icon={<AccessTimeIcon />}
        />
      </div>

      <p className={styles.content}>{quizDecription} </p>
      <Divider sx={{ borderColor: "#9DACBA" }} />
      {payload && !isForwardedQuiz ? (
        <p className={styles.total_question}>
          {
            `${t("total_question_answred")}: ${answredUseCases} /
          ${totalUseCases}`}
        </p>
      ) : (
        <p className={styles.total_question}>
          { `${t("use_case_forwarded")}:`}
        </p>
      )}

      <Stepper activeStep={activeStep} orientation="vertical" nonLinear>
        {steps.map((step, index) => (
          <Step
            key={step.title}
            completed={step?.questions
              .map((el) => el.id)
              .every((e) => !!payload[e])}
          >
            <StepLabel
              color="inherit"
              onClick={handleStep(index, step)}
              StepIconComponent={(props) => CustomStepIcon(props, step)}
            >
              {" "}
              <span className={styles.use_case}>
                {step[translate("title")] || t("not_specified")}
              </span>
            </StepLabel>
            {/* <StepContent>
              {step.questions.map((el, i) => (
                <div key={i} style={{ display: "flex" }}>
                  { }
                  <img
                    src={
                      !!payload[el.id]
                        ? CheckedQuestion
                        : forwardingQuizz?.some(
                          (item) => item?.question_id === el.id
                        )
                          ? ForwardedQuestion
                          : UncheckedQuestion
                    }
                    alt="React Logo"
                  ></img>
                  <p
                    onClick={() => handleClickQuestion(i)}
                    style={{
                      padding: "0 5px",
                      cursor: "pointer",
                      fontWeight: currentQuestion === i ? "bold" : "",
                    }}
                  >
                    Question {i + 1}
                  </p>
                </div>
              ))}
            </StepContent> */}
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
